import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { frontendURL } from 'dashboard/helper/URLHelper';
import CatalogSourcesPage from 'catalog/pages/CatalogSourcesPage.vue';
import CatalogProductsPage from 'catalog/pages/CatalogProductsPage.vue';
import CatalogProductSetsPage from 'catalog/pages/CatalogProductSetsPage.vue';
import CatalogProductSetFormPage from 'catalog/pages/CatalogProductSetFormPage.vue';

const meta = {
  permissions: ['administrator'],
  // Note: No featureFlag here - the page handles displaying a disabled state
};

const metaCatalog = { ...meta, featureFlag: FEATURE_FLAGS.CATALOG };

export const routes = [
  {
    path: frontendURL('accounts/:accountId/catalogs'),
    redirect: to => ({
      name: 'catalog_sources',
      params: { accountId: to.params.accountId },
    }),
  },
  {
    path: frontendURL('accounts/:accountId/catalogs/sources'),
    component: CatalogSourcesPage,
    name: 'catalog_sources',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/catalogs/products'),
    component: CatalogProductsPage,
    name: 'catalog_products',
    meta: metaCatalog,
  },
  {
    path: frontendURL('accounts/:accountId/catalogs/sets'),
    component: CatalogProductSetsPage,
    name: 'catalog_product_sets',
    meta: metaCatalog,
  },
  {
    path: frontendURL('accounts/:accountId/catalogs/sets/new'),
    component: CatalogProductSetFormPage,
    name: 'catalog_product_set_new',
    meta: metaCatalog,
  },
  {
    path: frontendURL('accounts/:accountId/catalogs/sets/:setId/edit'),
    component: CatalogProductSetFormPage,
    name: 'catalog_product_set_edit',
    meta: metaCatalog,
  },
];
